import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { province, ProvinceManipulationViewModel } from "./provinceManipulation-viewModel"

export class ProvinceManipulationView extends View<ProvinceManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-06A781F4-C740-43DD-9DC8-F0A9B45E5B8A"
    }
    loadHtml(): string {
        let element = require('./provinceManipulation.html').default;
        let style = require('./provinceManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set provinces(v: ObservableArray<province>) { this._provinces = v; } public get provinces(): ObservableArray<province> { return this._provinces;} private _provinces: ObservableArray<province>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestProvinceCreation(){
        this.dataContext.requestProvinceCreation();
    }

}
